import React from "react";
import { Button, Col, FormControl, FormGroup, FormLabel, Row } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import { DisplayBox } from "../../components";
import { ApiHelper, DateHelper, UserHelper } from "../../helpers";

interface Props { }

export const AffiliateSummary: React.FC<Props> = props => {
  const date = new Date();
  const [startDate, setStartDate] = React.useState(new Date(date.getFullYear(), date.getMonth() - 1, 1));
  const [endDate, setEndDate] = React.useState(new Date(date.getFullYear(), date.getMonth(), 0));
  const [data, setData] = React.useState<any[]>([]);
  const [redirect, setRedirect] = React.useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.currentTarget.value;
    switch (e.currentTarget.id) {
      case "startDate": setStartDate(DateHelper.convertToDate(val)); break;
      case "endDate": setEndDate(DateHelper.convertToDate(val)); break;
    }
  }

  const handleShow = (e: React.MouseEvent) => {
    e.preventDefault();
    ApiHelper.post("/affiliateSettings/adminCommissions", { startDate, endDate }).then(data => {
      setData(data);
    })
  }

  const getResults = () => {
    if (data.length > 0) {
      const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
      const result: any[] = [];

      data.forEach(d => {
        const currency = formatter.format(d.totalCommission);
        const departmentId = d.departmentId;
        result.push(<tr><td><a href="about:blank" onClick={(e) => { e.preventDefault(); impersonate(departmentId) }}>{d.name}</a></td><td>{currency}</td></tr>);
      });
      return <table className="table">{result}</table>
    }
  }

  const impersonate = async (departmentId: number) => {
    const department = await ApiHelper.get("/departments/impersonate/" + departmentId);

    UserHelper.departments.push(department);
    UserHelper.currentDepartment = department;
    UserHelper.departmentChanged = true;
    ApiHelper.setDefaultPermissions(UserHelper.currentDepartment.jwt);
    setRedirect("/settings/affiliate");
  }

  if (redirect !== "") return <Redirect to={redirect} />
  else {
    const startDateString = (startDate) ? DateHelper.formatHtml5Date(DateHelper.convertToDateOnly(startDate)) : "";
    const endDateString = (endDate) ? DateHelper.formatHtml5Date(DateHelper.convertToDateOnly(endDate)) : "";

    return (
      <DisplayBox headerIcon="fas fa-comments" headerText="Affiliate Summary" >
        <Row>
          <Col>
            <FormGroup>
              <FormLabel htmlFor="startDate">Start Date</FormLabel>
              <FormControl id="startDate" value={startDateString} onChange={handleChange} type="date" />
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <FormLabel htmlFor="endDate">End Date</FormLabel>
              <FormControl id="endDate" value={endDateString} onChange={handleChange} type="date" />
            </FormGroup>
          </Col>
        </Row>
        <Button variant="success" block onClick={handleShow}>Show</Button>
        {getResults()}
      </DisplayBox>
    );
  }

};